import React from "react";
import {
  cloneElement,
  isValidElement,
  type ReactElement,
  type ReactNode,
} from 'react';
import { EMAIL_BUILDER_DOM_ID_PREFIX, useStableDomId } from '../../useStableDomId';
import { PropertyRow } from './PropertyRow';
import type { FieldReset } from '../../domain/baselines';

type FieldStackProps = {
  label: string;
  children: ReactNode;
  id?: string;
  reset?: FieldReset;
};

export function FieldStack({ label, children, id, reset }: FieldStackProps) {
  const generatedId = useStableDomId(EMAIL_BUILDER_DOM_ID_PREFIX);
  const controlId = id ?? generatedId;

  if (isValidElement(children)) {
    const child = children as ReactElement<{ id?: string }>;
    return (
      <PropertyRow label={label} htmlFor={controlId} reset={reset}>
        {cloneElement(child, { id: child.props.id ?? controlId })}
      </PropertyRow>
    );
  }

  return (
    <PropertyRow label={label} reset={reset}>
      {children}
    </PropertyRow>
  );
}
